module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Ga-Ha-Ia-Ga.385051f9.png";